import type { Category, Genre } from '../grab/types'
import type { Lang } from './grab'
import { I18n } from './i18n'

export type CategorizedGenres = {
  key: string
  category: Category
  genres: Genre[]
}

export const groupTagsByCategory = (genres: Genre[], { lang }: { lang: Lang }, onlyFilterable = false): CategorizedGenres[] => {
  const defaultCategoryKey = I18n.SPECIALTIES[lang]
  const defaultCategory = { name: defaultCategoryKey, filterable: true, index: -1 }
  const intermediateGrouping: Record<string, CategorizedGenres> = {}

  for (const genre of genres.sort((a, b) => a.name.localeCompare(b.name))) {
    const categoryKey = genre.category ? genre.category.name : defaultCategoryKey
    const category = genre.category ?? defaultCategory

    if (!onlyFilterable || category.filterable) {
      if (!intermediateGrouping[categoryKey]) {
        intermediateGrouping[categoryKey] = {
          key: `${category.index}_${category.name}`,
          category: category,
          genres: [],
        }
      }
      intermediateGrouping[categoryKey].genres.push(genre)
    }
  }

  const categorizedArray: CategorizedGenres[] = Object.values(intermediateGrouping)
  categorizedArray.sort((a, b) => a.category.index - b.category.index)

  return categorizedArray
}
